export default "__VITE_ASSET__TF6I$5Kq__"